import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text as TextDs } from '@leroy-merlin-br/backyard-react-ui'

const textStyles = ({ theme }) => css`
    label: text;

    color: ${theme.colors.n600};
`

export const Text = styled(TextDs)(textStyles)

const linkStyles = ({ theme }) => css`
    label: link;

    color: ${theme.colors.p600};
`

export const Link = styled('a')(linkStyles)

const imgStyles = ({ theme }) => css`
  label: image;

  display: block;
  height: 156px;
  margin: ${theme.spacings.tera} auto;
  margin-top: 0;
  width: 78px;
`

export const Img = styled('img')(imgStyles)

const buttonContentStyles = () => css`
    label: button_container;

    display: flex;
    justify-content: center;
`
export const ButtonContent = styled('div')(buttonContentStyles)
